// let bodyHeight = document.body.clientHeight;
// let bodyWidth = document.body.clientWidth;
// const player = document.querySelector(".hero__player");
// const ball = document.querySelector(".hero__ball");

// window.onresize = function(e) {
//     bodyHeight = document.body.clientHeight;
//     bodyWidth = document.body.clientWidth;

//     if (bodyWidth < 1025) {
//         player.removeAttribute("style");
//         ball.removeAttribute("style");
//     }
// };

// document.body.addEventListener("mousemove", function(e) {
//     if (bodyWidth > 1024) {
//         let clientX = e.clientX;
//         let clientY = e.clientY;
//         let widthPercent = (clientX * 100) / bodyWidth;

//         //let fbSize = 95 - widthPercent / 100 <= 70 ? 70 : 95 * widthPercent / 100;
//         let fbSize = 60 + widthPercent * 0.14;
//         let fbX = 24.5 - widthPercent * 0.21;
//         let fbY = 6.25 + widthPercent * 0.08;
//         let pV = 83.5 - widthPercent * 0.18;

//         window.requestAnimationFrame(function() {
//             player.style.backgroundPositionX = 35 + widthPercent * 0.6 + "%";
//             player.style.backgroundPositionY = pV + "%";
//             ball.style.backgroundPositionX = fbX + "%";
//             ball.style.backgroundPositionY = fbY + "%";
//             ball.style.backgroundSize = fbSize + "px";
//         });
//     }
// });

let input = document.querySelector(".footer__email");
let submit = document.querySelector(".footer__email-submit");
submit.disabled = true;
input.addEventListener("keyup", function() {
    if (this.value.length > 3 && this.value.indexOf("@") != "-1" && this.value.indexOf(".") != "-1")
        submit.disabled = false;
    else submit.disabled = true;
});
